import type { RouteObject } from 'react-router';

import { RequirePermission } from '@saniplus/ui';

import { PermissionFallback } from '../../components/shared/PermissionFallback';

/**
 * The three Pointages routes, code-split per route (D-17), for the integrator
 * to splice under the authenticated shell.
 *
 * `/pointages/en-cours` is declared BEFORE `/pointages/:id`, because it would
 * otherwise be read as a punch id and answer "introuvable" — the one route
 * ordering bug this feature can ship.
 *
 * One gate for the section: every screen here reads punches (`punch:read`).
 * The corrections queue that used to sit at `/pointages/ajustements` behind a
 * second `punch:adjust` gate was retired on 2026-09-02 — a correction is made
 * on the session it belongs to, not reviewed in a register of its own.
 *
 * The gate is not a security control (the API scopes and answers 404 on its
 * own); it exists so the UI never offers a door that is already locked, and it
 * renders an explanation rather than redirecting.
 */

export const routes: RouteObject[] = [
  {
    path: '/pointages',
    element: <RequirePermission permission="punch:read" fallback={<PermissionFallback />} />,
    children: [
      {
        index: true,
        lazy: async () => ({
          Component: (await import('./pages/PunchesHistoryPage')).PunchesHistoryPage,
        }),
      },
      {
        path: 'en-cours',
        lazy: async () => ({
          Component: (await import('./pages/PunchesLivePage')).PunchesLivePage,
        }),
      },
      {
        path: ':id',
        lazy: async () => ({
          Component: (await import('./pages/PunchDetailPage')).PunchDetailPage,
        }),
      },
    ],
  },
];
